<template><div><h1 id="umlagern-innerhalb-lager" tabindex="-1"><a class="header-anchor" href="#umlagern-innerhalb-lager"><span>Umlagern innerhalb Lager</span></a></h1>
<p>Umlagern innerhalb Lager — Umlagerung im selben Lager</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Umlagern innerhalb eines Lager wird benötigt für 2-stufige Kommissionierung oder die Verwaltung von mehreren Lagerplätzen desselben Artikels. Es werden hier nur jene Felder und Funktionen detailliert besprochen, die sich von denjenigen in <RouteLink to="/referenz/refs/ft.refdata.umlagern_vLaL.html" title="VON Lager AN Lager umlagern">VON Lager AN Lager umlagern</RouteLink> unterscheiden (Dies gilt auch für die weiteren Umlagerungsaufträge). Die umzulagernden Artikel sind in den <RouteLink to="/referenz/refs/ft.refadata.umlagerpos.html" title="Umlagern Positionen">Umlagerungspositionen</RouteLink> definiert.</p>
<p>Pfad: <code v-pre>Logistik → Verarbeitungsläufe → Umlagerungen → Innerhalb Lager</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobdatum/Laufnr</dt>
<dd>
<p>Job-Identifikation, bestehend aus Jobdatum, Laufnummer</p>
</dd>
<dt>Status</dt>
<dd>
<p>Anzeige des Auftragsstatus:<br>1 = erfasst, nicht verarbeitet<br>2 = in Verarbeitung nach Status 1 (nur technischer Status, für den Benutzer nicht sichtbar)<br>3 = Lieferschein gedruckt<br>4 = in Verarbeitung nach Status 3 (nur technischer Status, für den Benutzer nicht sichtbar)<br>5 = abgeschlossen</p>
</dd>
<dt>von Lager</dt>
<dd>
<p>Auslieferlager, aus dem die Artikel geliefert werden</p>
</dd>
<dt>an Lager</dt>
<dd>
<p>Ziellager, in das die Artikel geliefert werden</p>
</dd>
<dt>Auslieferdatum</dt>
<dd>
<p>Datum, an dem die Auslieferung erfolgen soll. Damit können Umlagerungsaufträge analog normalen Aufträgen in die Zukunft terminiert werden.</p>
</dd>
<dd>
<p>Validierung: Das Auslieferungsdatum kann (ab dem Zeitpunkt, an dem der Lieferschein gedruckt werden soll) nur noch in einem Intervall zwischen [Heute -60 Tage] bis [Heute +7 Tage] angegeben werden. Umlagerungsaufträge können also bis 2 Monate rückwirkend und 1 Woche im voraus verarbeitet werden. Die Erfassung (ohne Verarbeitung) ist auch ausserhalb dieses Zeitraums möglich.</p>
</dd>
<dt>Empfangsdatum</dt>
<dd>
<p>Empfangsdatum: Datum, zu dem die Umlagerung im System vermerkt wird. Beim Verbuchen der bestätigten Mengen zeigt das System den Standardvorschlag = Tagesdatum. Dieses Datum kann geändert werden, womit auch rückwirkend Bewegungen ins System eingebucht werden können, was v.a. für die Inventur gebraucht wird</p>
</dd>
<dt>Partientyp</dt>
<dd>
<p>R = Retourenumlagerung (wird im Umlagerungskopf definiert), der Bewegungstyp ist &quot;U&quot;</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="innerhalb-lager-umlagern" tabindex="-1"><a class="header-anchor" href="#innerhalb-lager-umlagern"><span>Innerhalb Lager umlagern</span></a></h3>
<p>Outputbeispiel Lieferschein</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Innerhalb Lager umlagern:</span>
<span class="line"></span>
<span class="line">                                             Laden2 Zürich</span>
<span class="line">                                             Schalter</span>
<span class="line">                                             Molkenstrasse 21</span>
<span class="line">                                             8050 Zürich</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                                             Zürich, 12.05.2000 leh</span>
<span class="line"></span>
<span class="line">VON Lager:    031,161 Laden2 Zürich</span>
<span class="line"> AN Lager:    031,161 Laden2 Zürich</span>
<span class="line">Ausl.Dat.: 12.05.2000   EmpfDat: 12.05.2000 PTyp:</span>
<span class="line"></span>
<span class="line">                                    Artikel</span>
<span class="line"> Btyp Art.Nr  Art.Bezeichnung vonP  anP bestellt        zu lief.  bestät. Dif</span>
<span class="line"> ---- ------- --------------- ---- ---- --------        -------- -------- ---</span>
<span class="line"> U    01510   Kinderkarte Gog V  1 V  2        2               2        2</span>
<span class="line">-----------------------------------------------------------------------------</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refadata.umlagerpos.html" title="Umlagern Positionen">Umlagerungspositionen</RouteLink></p>
</div></template>


